import { useEffect, useState } from 'react';

import './Carousel.css';

function CarouselItem({ activeItem, isAnimationPaused }) {
  const [fadeOut, setFadeOut] = useState<string>();

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut('fadeOut');
    }, 3500);
    return () => {
      if (interval) {
        clearInterval(interval);
        setFadeOut('');
      }
    };
  }, []);

  return (
    activeItem && (
      <div className={`tiles_container ${isAnimationPaused ? 'no-animation' : ''}`}>
        {activeItem.images.map((image, index) => (
          <img
            // The tile class is index based and drives positioning and the fade animation.
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={`tile${index} ${fadeOut}`}
            src={image.src}
            alt={`${image.alt}`}
          />
        ))}
      </div>
    )
  );
}

export default CarouselItem;
